export const DESKTOP_AD_UNIT = 'general_vast';
export const MOBILE_AD_UNIT = 'Onedio.com_Mobile_Preroll';
